import { useEffect } from 'react';
import { tss } from 'tss-react';

import { IncorporationShare } from 'api/recipe/GetRecipeIdV1';
import Detail from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Detail/Index';
import Overview from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Overview/Index';
import * as State from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/State';
import { RecipeErpViewData } from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/useData';
import useData from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/useData';
import { RecipeErpViewHandlers } from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/useState';
import useState from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/useState';
import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import LoadingSpinner from 'components/desktop/_general/Loading/LoadingSpinner';
import { useIsHandlerLoaded } from 'hooks/useIsLoading';
import * as ErpRecipe from 'types/Recipe/Detail/ErpNew/ErpRecipe';
import { Recipe } from 'types/Recipe/Recipe';
import { Segment } from 'types/Recipe/Segment';
import * as SegmentList from 'types/Recipe/SegmentList';

type IncorporationShareWithIndex = IncorporationShare & { index: number };

type IProps = {
	segments: Segment[];
	recipe: Recipe;
	incorporationShares: IncorporationShareWithIndex[];
};

const Index = (props: IProps) => {
	const data = useData();
	const { state, handlers } = useState();
	const { classes } = useStyles();

	const [isLoaded, initialize] = useIsHandlerLoaded(() =>
		handlers.initialize({
			recipeId: props.recipe.id,
			ingredients: SegmentList.mapToErpMappingList(props.segments),
		})
	);

	useEffect(() => {
		initialize();
	}, [props.segments]);

	const defaultProps: RecipeErpViewComponentProps = {
		state: state,
		handlers: handlers,
		data: data,
	};

	const selectedRecipe = state.erpRecipes.find((e) => e.id === state.erpRecipeId);
	const hasSelectedRecipe = Boolean(selectedRecipe);

	return (
		<div className={classes.container}>
			<RenderIf condition={!isLoaded}>
				<LoadingSpinner style={{ marginTop: '40px' }} />
			</RenderIf>
			<RenderIf condition={isLoaded}>
				<RenderIf condition={!hasSelectedRecipe}>
					<Overview
						{...defaultProps}
						ingredientMapping={SegmentList.mapToErpMappingList(props.segments)}
					/>
				</RenderIf>
				<RenderIf condition={hasSelectedRecipe}>
					<Detail
						{...defaultProps}
						erpRecipe={selectedRecipe ?? ErpRecipe.create()}
						segments={props.segments}
						recipe={props.recipe}
						incorporationShares={props.incorporationShares}
					/>
				</RenderIf>
			</RenderIf>
		</div>
	);
};

export const useStyles = tss.create({
	container: {
		paddingTop: '15px',
	},
});

export default Index;

export interface RecipeErpViewComponentProps {
	state: State.Type;
	handlers: RecipeErpViewHandlers;
	data: RecipeErpViewData;
}
